import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const ComingSoon = ({
  title = "Something Exciting is Coming!",
  subtitle = "Stay tuned for a big reveal.",
  launchDate,
}) => {
  const formattedDate = launchDate
    ? new Date(launchDate).toLocaleDateString(undefined, {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        flexDirection: "column",
        px: 2,
        background: "linear-gradient(135deg, #FDE68A, #FCA5A5)",
        borderRadius: 3,
        boxShadow: 3,
      }}
    >
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        🚀 {title}
      </Typography>
      <Typography variant="h6" sx={{ mb: 3 }}>
        {subtitle}
      </Typography>
      {formattedDate && (
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
          Coming Soon
        </Typography>
      )}
      <Button variant="contained" color="primary" size="large">
        Notify Me
      </Button>
    </Box>
  );
};

export default ComingSoon;
